import { AuthenticatedHttp } from '@/http/axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNotify } from '@/components/snackbar';

export function useDeleteApiKey(currentPage = 1, resultsCount = 0) {
    const notify = useNotify();
    const queryClient = useQueryClient();

    const handleDeleteApiKey = async (id) => {
        try {
            const { data } = await AuthenticatedHttp.delete(`/public_api/api_key/${id}/`);
            return data;
        } catch (error) {
            notify.error('Algo deu errado ao deletar API key!');
            throw error;
        }
    };

    const deleteApiKeyMutation = useMutation({
        mutationFn: (apiKeyId) => handleDeleteApiKey(apiKeyId),
        onSuccess: () => {
            notify.success('Chave de API deletada com sucesso!');
            queryClient.invalidateQueries({ queryKey: ['api-keys'] });
        },
        onError: (error) => {
            console.error('Erro ao deletar API key:', error);
            notify.error('Erro ao deletar chave de API. Tente novamente.');
        }
    });

    return {
        deleteApiKey: deleteApiKeyMutation.mutate,
        deleteApiKeyAsync: deleteApiKeyMutation.mutateAsync,
        isDeleting: deleteApiKeyMutation.isLoading,
        error: deleteApiKeyMutation.error,
    };
}
